/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/SplitByN.ts
 * @create:      2025-06-26 13:17:41.963
 * @modify:      2025-07-11 21:19:12.843
 * @version:     6.0.0
 * @times:       7
 * @lines:       49
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Splits a string into substrings of a specified length.
 *
 * @param s - The input string to split.
 * @param n - The maximum length of each substring.
 * @param fromLeft - If `true`, splits from left to right; otherwise, splits from right to left (default).
 * @returns An array of substrings, each with a maximum length of `n`.
 *
 * @since 4.0.0
 * @version 2021-12-14
 */
export function SplitByN(s: string, n: number, fromLeft?: boolean) {
    const reg = fromLeft !== true ? `.{1,${n}}(?=(.{${n}})+(?!.))|.{1,${n}}$` : `.{1,${n}}`;

    return s.match(new RegExp(reg, "g")) as string[];
}
